module.exports = __webpack_public_path__ + "img/bankole_esan.c5bb9894.webp";